import logo from '../assets/images/trikon-logo.png';

const links = [
  { label: 'Build', href: '#model' },
  { label: 'Invest', href: '#opportunities' },
  { label: 'Raise', href: '#path' },
];

function NavBar({ activeSection }) {
  return  (
    <nav className="topnav">
      <div className="nav-logo">
        TRI<span>KON</span>
      </div>

      {/* <div className="nav-logo">
  <img src={logo} alt="Trikon Logo" className="logo-img" />
</div> */}

      <div className="nav-links">
        {links.map((link) => (
          <a
            key={link.href}
            href={link.href}
            className={activeSection === link.href.replace('#', '') ? 'active' : ''}
          >
            {link.label}
          </a>
        ))}
      </div>

      <div className="nav-actions">
        <a href="#contact" className="nav-login">
          Login
        </a>
        <a href="#contact" className="nav-cta">
          Get Started
        </a>
      </div>
    </nav>
  );
}

export default NavBar;
